import type { PersonInvolvementKind } from "../types/involvement.js";

/**
 * Written when the person's record is created and never started, replaced or
 * ended by hand: who created a person's record is a fact about how it began,
 * not a part anybody holds.
 */
export const isInvolvementKindSetAtCreation = (
  kind: PersonInvolvementKind,
): boolean => kind === "created_by";
